import { UpdateSundvaegtProgram } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const updateNnSundVaegtProgram = async (
    updateSundVaegtProgram: UpdateSundvaegtProgram,
): Promise<null> => {
    return await fetchIStatus<null, UpdateSundvaegtProgram>(
        '/api/nnsundvaegt/program',
        'PATCH',
        updateSundVaegtProgram,
    );
};
